import { render, staticRenderFns } from "./navPage.vue?vue&type=template&id=524e5c03&scoped=true"
import script from "./navPage.vue?vue&type=script&lang=js"
export * from "./navPage.vue?vue&type=script&lang=js"
import style0 from "./navPage.vue?vue&type=style&index=0&id=524e5c03&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524e5c03",
  null
  
)

export default component.exports